const root = document.documentElement;

const setKeyboard = () => {
  root.classList.add("is-keyboard-nav");
  root.classList.remove("is-pointer-nav");
};

const setPointer = () => {
  root.classList.remove("is-keyboard-nav");
  root.classList.add("is-pointer-nav");
};

window.addEventListener(
  "keydown",
  (e) => {
    if (e.key === "Tab" || e.key.startsWith("Arrow")) setKeyboard();
  },
  { passive: true },
);

window.addEventListener("mousedown", setPointer, { passive: true });
window.addEventListener("touchstart", setPointer, { passive: true });
